import { adminHttpClient } from "../../../commons/adminHttpClinet";

export const getPlaidDetails = (userId: string, isPaymentOption: boolean): Promise<any> => {
    return adminHttpClient.get(`/api/Admin/AdminBankAccount/plaid-item-details?UserId=${userId}&IsPaymentOption=${isPaymentOption}`)
}